const getUserIP = async () => {
  try {
    const response = await fetch("https://api64.ipify.org?format=json");
    const data = await response.json();
    return data.ip;
  } catch (error) {
    console.error("An error occurred while fetching the IP address:", error);
    return null;
  }
};

export default getUserIP;
